const SERVER_URL = 'https://montybici.herokuapp.com/api/';
export default SERVER_URL;